import React from "react";
import splashscreenStyles from "./splashscreen.module.css";

const Splashscreen = () => {
  return (
    <div className={splashscreenStyles.container}>
      <svg width="100%" height="100%">
        <rect x="0" y="0" width="100%" height="100%" fill="#051622">
          {" "}
        </rect>
        <text x="50%" y="50%" textAnchor="middle" fill="#051622">
          Welcome
        </text>
      </svg>
    </div>
  );
};

export default Splashscreen;
